import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import VueCarousel from "vue-carousel";

import App from "./App.vue";
import router from "./router";
import store from "./store";

import "./assets/icomoon/style.css";
import "./assets/scss/app.scss";
import "./components";
import "./plugins";
import { init, onLogout } from "./setup/api";

Vue.use(BootstrapVue);
Vue.use(VueCarousel);

init();

let isLoggingOut = false;
onLogout(() => {
  if (isLoggingOut) return;
  isLoggingOut = true;

  store.dispatch("logout").then(() => {
    const currentRoute = router.currentRoute;
    if (currentRoute.meta.protected) {
      router.replace({
        name: "login",
        query: { next: currentRoute.fullPath, expired: "1" }
      });
    }
    isLoggingOut = false;
  });
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

if (document.location.host.split(".")[0].toLocaleLowerCase() === "none") {
  document.location.href = "https://do-zero-ao-digital.club.looma.app.br/";
}
